import maxSize from 'popper-max-size-modifier';
import { Modifier, ModifierArguments, Obj } from '@popperjs/core';

/**
 * Prevents a Popper instance from overflowing the viewport
 * Source: https://popper.js.org/docs/v2/modifiers/community-modifiers/
 *
 * TODO: Replace with more robust solution (this makes scroll performance a bit janky)
 */
const popperMaxSizeModifiers: Modifier<string, Obj>[] = [
  maxSize,
  {
    name: 'applyMaxSize',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['maxSize'],
    fn({ state }: ModifierArguments<Obj>): void {
      const { height } = state.modifiersData.maxSize;
      state.styles.popper.display = 'flex'; /* 
        Added `display: flex` to example (https://codesandbox.io/s/great-tesla-3roz7?file=/src/index.js), 
        which seems to be required for overflow scrolling  */
      state.styles.popper.maxHeight = `${height}px`;
    },
  },
];

export default popperMaxSizeModifiers;
